export default __webpack_public_path__ + "static/bell_b.3b6d3393047d5146e3da3723f14f0c9a.svg";